export const links = {
  facebook: '',
  twitter: 'https://twitter.com/GaiaEverWorld',
  telegram: 'https://t.me/GaiaEverworld',
};
